import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4f806c7e")

_pushScopeId("data-v-4f806c7e")
const _hoisted_1 = { style: {"height":"100%","position":"relative"} }
const _hoisted_2 = { style: {"position":"fixed","z-index":"1000","top":"0","left":"0","right":"0"} }
const _hoisted_3 = {
  class: "new_head",
  style: {"width":"100%","background":"#3361b9","height":"62px"}
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", {
    class: "geo-style2",
    style: {"font-size":"21px","color":"#fff"}
  }, "设备管理")
], -1)
const _hoisted_5 = { style: {"padding":"2%"} }
const _hoisted_6 = { class: "editDiaLOG" }
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 确认申请 ")
const _hoisted_9 = { class: "editDiaLOG_string" }
const _hoisted_10 = { class: "check_size" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { style: {"display":"flex","margin-bottom":"20px"} }, [
  /*#__PURE__*/_createVNode("div", { class: "title_span" }),
  /*#__PURE__*/_createVNode("h5", { style: {"font-weight":"bold","margin-bottom":"0px"} }, "设备属性")
], -1)
const _hoisted_12 = { class: "check_size" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { style: {"display":"flex","margin-bottom":"20px"} }, [
  /*#__PURE__*/_createVNode("div", { class: "title_span" }),
  /*#__PURE__*/_createVNode("h5", { style: {"font-weight":"bold","margin-bottom":"0px"} }, "硬件参数")
], -1)
const _hoisted_14 = { class: "check_size" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { style: {"display":"flex","margin-bottom":"20px"} }, [
  /*#__PURE__*/_createVNode("div", { class: "title_span" }),
  /*#__PURE__*/_createVNode("h5", { style: {"font-weight":"bold","margin-bottom":"0px"} }, "其他")
], -1)
const _hoisted_16 = { class: "dialog-footer" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 确认 ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 取消 ")
const _hoisted_19 = { class: "dialogTitle" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "上传性能数据", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "el-icon-upload" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖到此处，或 "),
  /*#__PURE__*/_createVNode("em", null, "点击上传")
], -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "el-upload__tip" }, " 只能上传excel文件，且不超过50MB ", -1)
const _hoisted_24 = { class: "dialog-footer" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("重 置")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_27 = { class: "editDiaLOG" }
const _hoisted_28 = { class: "dialog-footer" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 确认添加 ")
const _hoisted_30 = { class: "devices_head" }
const _hoisted_31 = { id: "thead_devices" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "iconfont icon-shouji" }, null, -1)
const _hoisted_33 = { class: "thead_devices_right" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", null, "总设备数", -1)
const _hoisted_35 = { id: "thead_devices" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "iconfont icon-anzhuo" }, null, -1)
const _hoisted_37 = { class: "thead_devices_right" }
const _hoisted_38 = { id: "thead_devices" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "iconfont icon-ios" }, null, -1)
const _hoisted_40 = { class: "thead_devices_right" }
const _hoisted_41 = { style: {"background":"#f7f7f7","display":"flex","justify-content":"space-between"} }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_43 = { style: {"padding":"20px 0","display":"flex"} }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("批量上传")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("新增设备")
const _hoisted_46 = {
  style: {"width":"100%","padding":"10px"},
  class: "Ecard_mana",
  id: "trendChart"
}
const _hoisted_47 = { class: "testMain" }
const _hoisted_48 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("清空筛选")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("更多条件")
const _hoisted_52 = { style: {"margin-right":"10px"} }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { key: 2 }
const _hoisted_56 = { key: 3 }
const _hoisted_57 = { key: 4 }
const _hoisted_58 = { key: 5 }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { style: {"display":"flex"} }
const _hoisted_61 = /*#__PURE__*/_createTextVNode("申请借用")
const _hoisted_62 = /*#__PURE__*/_createTextVNode("归还设备")
const _hoisted_63 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_64 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_65 = {
  class: "spacName",
  style: {"display":"flex","justify-content":"flex-end","margin-bottom":"20px"}
}
const _hoisted_66 = /*#__PURE__*/_createVNode("div", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", null, [
          _createVNode("span", null, [
            _createVNode("img", {
              style: {"height":"50px","width":"55px","border-radius":"25px"},
              src: 
                'https://dayu.woa.com/avatars/' + _ctx.name_img + '/profile.jpg'
              
            }, null, 8, ["src"])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_el_dialog, {
            width: "30%",
            "custom-class": "custom-dialog",
            modelValue: _ctx.dialogFormVisible1,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogFormVisible1 = $event)),
            title: ""
          }, {
            footer: _withId(() => [
              _createVNode("span", _hoisted_7, [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editDay(_ctx.id, 1)))
                }, {
                  default: _withId(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withId(() => [
              _createVNode(_component_el_form, {
                model: _ctx.form,
                "label-width": "120px",
                size: "mini"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "归还日期" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.time,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.time = $event)),
                        type: "datetime",
                        placeholder: "Select date and time"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_el_dialog, {
            width: "50%",
            "custom-class": "custom-dialog",
            modelValue: _ctx.dialogFormVisible2,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogFormVisible2 = $event)),
            title: "设置显示字段"
          }, {
            footer: _withId(() => [
              _createVNode("span", _hoisted_16, [
                _createVNode(_component_el_button, {
                  onClick: _ctx.handleChange,
                  size: "small",
                  type: "primary"
                }, {
                  default: _withId(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogFormVisible2 = false)),
                  size: "small",
                  type: "primary"
                }, {
                  default: _withId(() => [
                    _hoisted_18
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withId(() => [
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.checkList_device,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.checkList_device = $event))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_row, null, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_properties, (item) => {
                          return (_openBlock(), _createBlock(_component_el_col, {
                            key: item.name,
                            span: 4
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_checkbox, {
                                style: {"margin-bottom":"10px"},
                                label: item.name
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(item.chinese_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.checkList_parameters,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.checkList_parameters = $event))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_row, null, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hardware_parameters, (item) => {
                          return (_openBlock(), _createBlock(_component_el_col, {
                            key: item.name,
                            span: 4
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_checkbox, {
                                style: {"margin-bottom":"10px"},
                                label: item.name
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(item.chinese_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.checkList_others,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.checkList_others = $event))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.other_info, (item) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: item.name,
                        label: item.name
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(item.chinese_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode("div", null, [
          _createVNode(_component_el_dialog, {
            modelValue: _ctx.dialogVisible,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dialogVisible = $event)),
            width: "30%",
            onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            title: _withId(() => [
              _createVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_el_divider)
              ])
            ]),
            footer: _withId(() => [
              _createVNode("span", _hoisted_24, [
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.submitUpload('no')))
                }, {
                  default: _withId(() => [
                    _hoisted_25
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.submitUpload('ok')))
                }, {
                  default: _withId(() => [
                    _hoisted_26
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withId(() => [
              _createVNode(_component_el_form, {
                model: _ctx.dialogForm,
                size: "small",
                "label-position": "top"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "上传文件" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_upload, {
                        class: "upload-demo",
                        drag: "",
                        action: "http://127.0.0.1:8081/api/v1/device/model_excel_upload/",
                        multiple: "",
                        limit: 10,
                        "before-remove": _ctx.beforeRemove,
                        "before-upload": _ctx.beforeUpload,
                        ref: 'upload',
                        "http-request": _ctx.UploadFile,
                        "file-list": _ctx.fileList1
                      }, {
                        tip: _withId(() => [
                          _hoisted_23
                        ]),
                        default: _withId(() => [
                          _hoisted_21,
                          _hoisted_22
                        ]),
                        _: 1
                      }, 8, ["before-remove", "before-upload", "http-request", "file-list"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_27, [
          _createVNode(_component_el_dialog, {
            "custom-class": "custom-dialog",
            modelValue: _ctx.dialogFormVisible,
            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.dialogFormVisible = $event)),
            title: ""
          }, {
            footer: _withId(() => [
              _createVNode("span", _hoisted_28, [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.edit()))
                }, {
                  default: _withId(() => [
                    _hoisted_29
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withId(() => [
              _createVNode(_component_el_form, {
                model: _ctx.form,
                style: {"padding":"0 10px"},
                "label-width": "120px",
                size: "mini",
                "label-position": "top"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_row, { gutter: 20 }, {
                    default: _withId(() => [
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "设备名" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.add.name,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.add.name = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "品牌" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.add.oem,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.add.oem = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "型号" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.add.model,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.add.model = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 20 }, {
                    default: _withId(() => [
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "CPU名" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.add.cpu_name,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.add.cpu_name = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "CPU型号" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.add.cpu_model,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.add.cpu_model = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "GPU型号" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.add.gpu_model,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.add.gpu_model = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 20 }, {
                    default: _withId(() => [
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "GPU名" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.add.gpu_name,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.add.gpu_name = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "分辨率" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.add.resolution,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.add.resolution = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "RAM(内存)" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.add.ram,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.add.ram = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 20 }, {
                    default: _withId(() => [
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "资产编号" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.add.asset_number,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.add.asset_number = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "核心数" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.add.core_num,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.add.core_num = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "屏幕刷新率" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.add.screen_refresh_rate,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.add.screen_refresh_rate = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 20 }, {
                    default: _withId(() => [
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "系统版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.add.os,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.add.os = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "CPU位数" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.add.cpu_digit,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.add.cpu_digit = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "CPU频率" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.add.cpu_frequency,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.add.cpu_frequency = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 20 }, {
                    default: _withId(() => [
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "平台" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.add.type,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.add.type = $event)),
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceType, (item, k) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: k,
                                      label: item,
                                      value: k
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "类型" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.add.area,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.add.area = $event)),
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sys, (item, k) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: k,
                                      label: item,
                                      value: k
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_30, [
          _createVNode("div", _hoisted_31, [
            _hoisted_32,
            _createVNode("div", _hoisted_33, [
              _createVNode("div", null, _toDisplayString(_ctx.managementList.count), 1),
              _hoisted_34
            ])
          ]),
          _createVNode("div", _hoisted_35, [
            _hoisted_36,
            _createVNode("div", _hoisted_37, [
              _createVNode("div", null, _toDisplayString(_ctx.managementList["安卓"]), 1),
              _createVNode("div", null, " 安卓设备数(国内:" + _toDisplayString(_ctx.managementList["国内"]) + " 海外:" + _toDisplayString(_ctx.managementList["海外"]) + ") ", 1)
            ])
          ]),
          _createVNode("div", _hoisted_38, [
            _hoisted_39,
            _createVNode("div", _hoisted_40, [
              _createVNode("div", null, _toDisplayString(_ctx.managementList["iOS"]), 1),
              _createVNode("div", null, " iOS设备数(国内:" + _toDisplayString(_ctx.managementList["iOS国内"]) + " 海外:" + _toDisplayString(_ctx.managementList["iOS海外"]) + ") ", 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_41, [
          _hoisted_42,
          _createVNode("div", _hoisted_43, [
            _createVNode(_component_el_button, {
              onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.upData())),
              size: "mini",
              type: "primary"
            }, {
              default: _withId(() => [
                _hoisted_44
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _ctx.addBtn,
              size: "mini",
              type: "primary"
            }, {
              default: _withId(() => [
                _hoisted_45
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_46, [
        _createVNode("div", _hoisted_47, [
          _createVNode(_component_el_form, {
            inline: true,
            size: "mini"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_form_item, { label: "关键词搜索" }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.ManagementData.search,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.ManagementData.search = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_form, {
            inline: true,
            size: "mini"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_form_item, { label: "品牌" }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.ManagementData.oem,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.ManagementData.oem = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.managementOptions['品牌列表'], (item, k) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: k,
                          label: item,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "CPU" }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.ManagementData.cpu_name,
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.ManagementData.cpu_name = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "内存" }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.ManagementData.ram,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.ManagementData.ram = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.managementOptions['内存列表'], (item, k) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: k,
                          label: item,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_ctx.many)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "GPU"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ManagementData.gpu,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.ManagementData.gpu = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.many)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: "当前借用人"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.ManagementData.borrower,
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.ManagementData.borrower = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.managementOptions['借用人列表'], (item, k) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: k,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_48, [
            _createVNode(_component_el_form, {
              inline: true,
              size: "mini"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.serch,
                      size: "mini"
                    }, {
                      default: _withId(() => [
                        _hoisted_49
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, {
                      size: "mini",
                      onClick: _ctx.empty
                    }, {
                      default: _withId(() => [
                        _hoisted_50
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, {
                      size: "mini",
                      type: _ctx.many ? 'primary' : '',
                      onClick: _ctx.many_click
                    }, {
                      default: _withId(() => [
                        _hoisted_51
                      ]),
                      _: 1
                    }, 8, ["type", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode("div", null, [
              _createVNode("span", _hoisted_52, "共" + _toDisplayString(_ctx.managementList?.count) + "条", 1),
              _createVNode("span", {
                onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.dialogFormVisible2 = true)),
                style: {"font-size":"17px","font-weight":"bold","cursor":"pointer"},
                class: "iconfont icon-chilun"
              })
            ])
          ]),
          _createVNode(_component_el_table, {
            data: _ctx.managementList?.results,
            size: "mini",
            "header-cell-style": {
              background: '#EEF2F5',
            }
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.all_check, (item) => {
                return (_openBlock(), _createBlock(_component_el_table_column, {
                  key: item,
                  label: _ctx.chinese(item)
                }, {
                  default: _withId((scope) => [
                    (item == 'status')
                      ? (_openBlock(), _createBlock("span", _hoisted_53, [
                          _createVNode("span", null, _toDisplayString(scope.row.status == 0 ? "空闲" : "借用中"), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item == 'type')
                      ? (_openBlock(), _createBlock("span", _hoisted_54, [
                          _createVNode("span", null, _toDisplayString(scope.row.type == 0 ? "安卓" : "iOS"), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item == 'borrower')
                      ? (_openBlock(), _createBlock("span", _hoisted_55, [
                          _createVNode("span", null, _toDisplayString(scope.row.borrower), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item == 'return_time')
                      ? (_openBlock(), _createBlock("span", _hoisted_56, [
                          _createVNode("span", null, _toDisplayString(scope.row.return_time), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item == 'area')
                      ? (_openBlock(), _createBlock("span", _hoisted_57, [
                          _createVNode("span", null, _toDisplayString(scope.row.area == 0 ? "国内" : "海外"), 1)
                        ]))
                      : (!_ctx.dis_check.some((v) => v === item))
                        ? (_openBlock(), _createBlock("div", _hoisted_58, [
                            (!scope.row.modify)
                              ? (_openBlock(), _createBlock("span", _hoisted_59, _toDisplayString(scope.row[item]), 1))
                              : (_openBlock(), _createBlock(_component_el_input, {
                                  key: 1,
                                  size: "mini",
                                  modelValue: scope.row[item],
                                  "onUpdate:modelValue": ($event: any) => (scope.row[item] = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                          ]))
                        : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128)),
              _createVNode(_component_el_table_column, { label: "状态" }, {
                default: _withId((scope) => [
                  _createVNode("span", null, _toDisplayString(scope.row.status == 0 ? "空闲" : "借用中"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                width: "250",
                fixed: "right",
                label: "操作"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", _hoisted_60, [
                    (scope.row.status == 0)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          onClick: ($event: any) => (_ctx.statusBtn(scope.row.id)),
                          size: "mini",
                          type: "primary"
                        }, {
                          default: _withId(() => [
                            _hoisted_61
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_el_popconfirm, {
                          key: 1,
                          onConfirm: ($event: any) => (_ctx.editDay(scope.row.id, 0)),
                          title: "确定归还"
                        }, {
                          reference: _withId(() => [
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "warning"
                            }, {
                              default: _withId(() => [
                                _hoisted_62
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["onConfirm"])),
                    _createVNode(_component_el_button, {
                      onClick: ($event: any) => (scope.row.modify = !scope.row.modify),
                      size: "mini",
                      type: scope.row.modify ? 'info' : 'warning'
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(scope.row.modify ? "取消" : "编辑"), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "type"]),
                    (scope.row.modify)
                      ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                          key: 2,
                          onConfirm: ($event: any) => (_ctx.handleDeleteScene(scope.row)),
                          title: "确定更改"
                        }, {
                          reference: _withId(() => [
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "success"
                            }, {
                              default: _withId(() => [
                                _hoisted_63
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["onConfirm"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_popconfirm, {
                      onConfirm: ($event: any) => (_ctx.deleteBtn(scope.row.id)),
                      title: "确定删除"
                    }, {
                      reference: _withId(() => [
                        _createVNode(_component_el_button, {
                          size: "mini",
                          type: "danger"
                        }, {
                          default: _withId(() => [
                            _hoisted_64
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createVNode("div", _hoisted_65, [
            _createVNode(_component_el_form, {
              style: {"display":"flex","align-items":"center"},
              inline: true,
              size: "mini"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  style: {"margin-bottom":"0"},
                  label: "每页"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ManagementData.size,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.ManagementData.size = $event)),
                      style: {"width":"55px","height":"28px"},
                      onChange: _cache[41] || (_cache[41] = ($event: any) => (_ctx.peloadChange_top('paging')))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  style: {"margin-bottom":"0"},
                  label: "条记录"
                }),
                _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                  default: _withId(() => [
                    _createVNode(_component_el_pagination, {
                      onCurrentChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.peloadChange_top())),
                      currentPage: _ctx.ManagementData.page,
                      "onUpdate:currentPage": _cache[43] || (_cache[43] = ($event: any) => (_ctx.ManagementData.page = $event)),
                      "page-size": _ctx.ManagementData.size,
                      style: {"text-align":"right"},
                      total: _ctx.managementList?.count,
                      layout: "total, prev, pager, next,jumper"
                    }, null, 8, ["currentPage", "page-size", "total"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _hoisted_66
        ])
      ])
    ])
  ]))
})